import styled from 'styled-components';

import FieldContainer from './FieldContainer';

export const CustomRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-bottom: 24px;

  > ${FieldContainer} {
    margin: 0 12px;
  }
  > ${FieldContainer}:first-child {
    margin-left: 0;
  }
  > ${FieldContainer}:last-child {
    margin-right: 0;
  }
`;
